var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayDotR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 4,
  height: 4,
  viewBox: "0 0 4 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2,
  fill: "#B5B5B5",
  fillOpacity: 0.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayDotR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gray-dot-r.fd53dd310b93a5707060c4685aceb613.svg";